import { Card } from 'antd';

import GeneralCompensations from './general/general-compensations.component';
import SubjectRelatedCompensations from './subject-related/subject-related-compensations.component';

export function Compensation() {
  return (
    <Card className='shadow-sm'>
      <GeneralCompensations />
      <SubjectRelatedCompensations />
    </Card>
  );
}
